// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NetworksControlPage {
  padding-left: 281px;
  background: #eff0f4;
  width: 100%;
  min-height: 100vh;
}
.NetworksControlPage__loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}
.NetworksControlPage__titleBlock {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px 24px;
  background: #fff;
  padding: 43px 40px 27px;
}
.NetworksControlPage__pageTitle {
  margin: 0;
  flex: 1 1 auto;
  min-width: min(100%, 200px);
  font-family: "Montserrat Regular", sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: inherit;
}
.NetworksControlPage__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
}
.NetworksControlPage__searchInput {
  width: 280px;
  max-width: 100%;
  height: 32px;
}
.NetworksControlPage__searchInput.ant-input-affix-wrapper {
  display: inline-flex;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}
.NetworksControlPage__searchInput .ant-input {
  line-height: 1.5715;
}
.NetworksControlPage__searchIcon {
  color: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
}
.NetworksControlPage__tableWrap {
  margin: 24px 40px 40px;
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.NetworksControlPage__egoRecommendTag.ant-tag {
  margin: 0;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 4px;
  color: #7c3a9e;
  background: #f5e6ff;
  border-color: #e9d4ff;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/NetworksControlPage/NetworksControlPage.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACJ;AAEE;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAAJ;AAGE;EACE,SAAA;EACA,cAAA;EACA,2BAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADJ;AAIE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAFJ;AAKE;EACE,YAAA;EACA,eAAA;EACA,YAAA;AAHJ;AAKI;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAHN;AAMI;EACE,mBAAA;AAJN;AAQE;EACE,0BAAA;EACA,aAAA;EACA,mBAAA;AANJ;AASE;EACE,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;AAPJ;AAUE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AARJ","sourcesContent":[".NetworksControlPage {\n  padding-left: 281px;\n  background: #eff0f4;\n  width: 100%;\n  min-height: 100vh;\n\n  &__loader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 400px;\n  }\n\n  &__titleBlock {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px 24px;\n    background: #fff;\n    padding: 43px 40px 27px;\n  }\n\n  &__pageTitle {\n    margin: 0;\n    flex: 1 1 auto;\n    min-width: min(100%, 200px);\n    font-family: 'Montserrat Regular', sans-serif;\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 32px;\n    color: inherit;\n  }\n\n  &__toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px;\n    flex: 0 0 auto;\n  }\n\n  &__searchInput {\n    width: 280px;\n    max-width: 100%;\n    height: 32px;\n\n    &.ant-input-affix-wrapper {\n      display: inline-flex;\n      align-items: center;\n      padding-top: 0;\n      padding-bottom: 0;\n    }\n\n    .ant-input {\n      line-height: 1.5715;\n    }\n  }\n\n  &__searchIcon {\n    color: rgba(0, 0, 0, 0.45);\n    display: flex;\n    align-items: center;\n  }\n\n  &__tableWrap {\n    margin: 24px 40px 40px;\n    background: #fff;\n    padding: 24px;\n    border-radius: 8px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  }\n\n  &__egoRecommendTag.ant-tag {\n    margin: 0;\n    font-size: 12px;\n    line-height: 1.3;\n    border-radius: 4px;\n    color: #7c3a9e;\n    background: #f5e6ff;\n    border-color: #e9d4ff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NetworksControlPage": `NetworksControlPage`,
	"NetworksControlPage__loader": `NetworksControlPage__loader`,
	"NetworksControlPage__titleBlock": `NetworksControlPage__titleBlock`,
	"NetworksControlPage__pageTitle": `NetworksControlPage__pageTitle`,
	"NetworksControlPage__toolbar": `NetworksControlPage__toolbar`,
	"NetworksControlPage__searchInput": `NetworksControlPage__searchInput`,
	"ant-input-affix-wrapper": `ant-input-affix-wrapper`,
	"ant-input": `ant-input`,
	"NetworksControlPage__searchIcon": `NetworksControlPage__searchIcon`,
	"NetworksControlPage__tableWrap": `NetworksControlPage__tableWrap`,
	"NetworksControlPage__egoRecommendTag": `NetworksControlPage__egoRecommendTag`,
	"ant-tag": `ant-tag`
};
export default ___CSS_LOADER_EXPORT___;
